import { render, staticRenderFns } from "./WrappingComponent.vue?vue&type=template&id=87293cb4"
import script from "./WrappingComponent.vue?vue&type=script&lang=js"
export * from "./WrappingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports